export default __webpack_public_path__ + "static/media/icon.65c9971e.svg";